import IOrderBy from 'shared/model/IOrderBy';
import {INotifyChannel, INotifyChannelEdit} from 'entities/notification';

type MutationResult = Promise<{data?: unknown, error?: unknown}>;

type Mutation<A> = readonly [(_arg: A) => MutationResult, ...unknown[]];

export interface INotifyChannelApi<T extends INotifyChannel> {
    useGetListQuery(_sort: IOrderBy | undefined): {data?: T[], isLoading: boolean},
    useGetActiveQuery(): {data?: T[]},
    useUpdateMutation(): Mutation<INotifyChannelEdit>,
    useDeleteMutation(): Mutation<number>,
    useSendTestNotifyMutation(): Mutation<number>,
}

export const canCreateNotifyChannel = (limit: number | undefined, activeCount: number | undefined): boolean => (
    limit === undefined || activeCount === undefined ? true : limit > activeCount
);
